/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button, DropDown, Input, ImageUpload } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { format, differenceInCalendarDays } from "date-fns";

import { SendOtpBooking } from "../../../utilities/api/courtBooking";
import { VerifyOtpModal } from "../CourtsBooking/VerifyOtpModal";
import {
  ValidateSessionBookingAttendeeUser,
  SessionBookingAmount,
} from "../../../utilities/api/session";
import {
  validateAlphabet,
  validateCharacterLength,
  validatePositiveValue,
  nameValidation,
  emailValidation,
} from "../../../utilities/utils";
import { toast } from "react-toastify";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.coachingSessionBooking;

const AddCoachingBookingDetails = ({
  data,
  updateData,
  sessionData,
  verifiedUser,
  setVerifiedUser,
  error,
  setError,
  setVerifyButton,
  verifyButton,
}: any) => {
  const { states } = useAppSelector((state) => state.states);

  const [modalShow, setModalShow] = useState(false);
  const [disableAll, setDisableAll] = useState(true);
  const [sendOtp, setSendOtp] = useState({
    phone: data?.phone || "",
    otpFor: "sessionBooking",
  });
  const [message, setMessage] = useState("");
  const [ratePerWeek, setRatePerWeek] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [amount, setAmountData] = useState({}) as any;
  const [offerData, setOfferData] = useState({}) as any;
  const [imgError, setImgError] = useState("");
  const [mounted, setMounted] = useState(false);
  const [igstChecked, seIgstChecked] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const _ratePerSession = sessionData?.sessionRates?.find?.(
      (_rate: any) => _rate?.noOfDays === data?.noOfDays
    )?.ratePerSession;

    setRatePerWeek(_ratePerSession * data?.noOfDays);
    let offerDataGet: any = {};
    if (sessionData?.sessionOffers?.length) {
      const sortedOffer = sessionData?.sessionOffers?.sort?.(
        (a: any, b: any) => a?.noOfWeeks - b?.noOfWeeks
      );
      sortedOffer?.forEach?.((_offer: any) => {
        if (Number(_offer?.noOfWeeks) <= Number(data?.noOfWeeks)) {
          offerDataGet = _offer;
        }
      });
    }
    setOfferData(offerDataGet);
    let getTotalTax = sessionData?.sessionTaxes?.find?.(
      (_tax: any) => _tax?.tax?.type === "IGST"
    );
    setTotalTax(getTotalTax?.percentage);
  }, []);

  useEffect(() => {
    if (mounted && verifiedUser.phone) {
      setDisableAll(false);
      setVerifyButton(true);
    }
  }, [mounted, verifiedUser.phone]);


  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  let slotPickerProps = {};
  if (sessionData?.id) {
    const sessionDays =
      sessionData?.sessionSlots?.map?.((_session: any) =>
        _session?.sessionDay?.toLowerCase?.()
      ) || [];
    let minDate = new Date();
    if (
      sessionData?.startDate &&
      differenceInCalendarDays(
        getFormatedDate(sessionData?.startDate),
        minDate
      ) > 0
    ) {
      minDate = getFormatedDate(sessionData?.startDate);
    }
    slotPickerProps = {
      minDate,
      mapDays: ({ date }: any) => ({
        disabled:
          sessionDays?.indexOf(date?.weekDay?.name?.toLowerCase?.()) === -1,
      }),
    };
    if (sessionData?.endDate) {
      slotPickerProps = {
        ...slotPickerProps,
        maxDate: getFormatedDate(sessionData?.endDate),
      };
    }
  }


  const handleSend = async () => {
    if (sendOtp.phone?.length == 10) {
      const result = await SendOtpBooking(sendOtp);
      if (result?.data?.statusCode === 200) {
        setModalShow(true);
        setMessage(result.data.data.otpNumber);
      } else {
        setMessage(result.response.data.message);
      }
      setError({ ...error, phone: "" });
    } else {
      setError({
        ...error,
        phone: getMessage.phone_maxLength,
      });
    }
  };

  const handleVerifiedUser = async () => {
    setVerifyButton(true);
    const result = await ValidateSessionBookingAttendeeUser({
      phone: data?.phone,
    });
    if (result?.status === 200) {
      let _userData = result?.data?.data;
      updateData({
        ...(_userData || {}),
        ...(_userData?.sessionAttendee || {}),
        image: _userData?.userImage,
        firstName: _userData?.firstName,
        lastName: _userData?.lastName,
        addressLine1: _userData?.address?.addressLine1 || "",
        addressLine2: _userData?.address?.addressLine2,
        landmark: _userData?.address?.landmark,
        city: _userData?.address?.city || "",
        country: _userData?.address?.country || "India",
        latitude: _userData?.address?.latitude,
        longitude: _userData?.address?.longitude,
        pincode: _userData?.address?.pincode || "",
        phone: _userData?.phone,
        state: _userData?.address?.state || "",
        gender: _userData?.gender || "",
        aadharNumber: _userData?.aadharNumber,
        birthDate: _userData?.birthDate || "",
        schoolName: _userData?.userSessionAttendee?.schoolName,
        parentName: _userData?.userSessionAttendee?.parentName,
        whatsAppNumber: _userData?.userSessionAttendee?.whatsAppNumber,
        haveIdProof: _userData?.userSessionAttendee?.haveIdProof,
      });
      setVerifiedUser({
        image: !!_userData?.userImage,
        firstName: !!_userData?.firstName,
        lastName: !!_userData?.lastName,
        addressLine1: !!_userData?.address?.addressLine1 || "",
        addressLine2: !!_userData?.address?.addressLine2,
        landmark: _userData?.address?.landmark,
        city: !!_userData?.address?.city as any || "",
        country: !!_userData?.address?.country as any || "India",
        latitude: !!_userData?.address?.latitude,
        longitude: !!_userData?.address?.longitude,
        pincode: !!_userData?.address?.pincode as any || "",
        phone: !!_userData?.phone,
        state: !!_userData?.address?.state as any || "",
        gender: !!_userData?.gender as any || "",
        aadharNumber: !!_userData?.aadharNumber,
        birthDate: !!_userData?.birthDate as any || "",
        schoolName: !!_userData?.userSessionAttendee?.schoolName,
        parentName: !!_userData?.userSessionAttendee?.parentName,
        whatsAppNumber: !!_userData?.userSessionAttendee?.whatsAppNumber,
        haveIdProof:
          typeof _userData?.userSessionAttendee?.haveIdProof === "boolean",
      });
      setError({
        phone:
          data?.phone?.length == 10
            ? ""
            : getMessage.phone_maxLength,
        firstName:
          _userData?.firstName?.length < 3 || _userData?.firstName?.length > 30
            ? getMessage.firstName_min_max
            : nameValidation(_userData?.firstName) == null
              ? getMessage.firstName_matches
              : "",
        lastName:
          _userData?.lastName?.length < 1 || _userData?.lastName?.length > 30
            ? getMessage.lastName_min_max
            : nameValidation(_userData?.lastName) == null
              ? getMessage.lastName_matches
              : "",
        // gender: _userData?.gender ? "" : getMessage.gender_required,
        gender: "",
        // birthDate: _userData?.birthDate ? "" : getMessage.dateOfBirth_required,
        birthDate: "",
        // addressLine1: _userData?.address?.addressLine1
        //   ? _userData?.address?.addressLine1.length > 50
        //     ? getMessage.addressLine1_maxLength
        //     : ""
        //   : getMessage.addressLine1_required,
        addressLine1:"",
        addressLine2:
          _userData?.address?.addressLine2.length > 50
            ? getMessage.addressLine2_maxLength
            : "",
        landmark:
          _userData?.address?.landmark.length > 50
            ? getMessage.landmark_maxLength
            : "",
        country:"",
        // city: _userData?.address?.city
        //   ? _userData?.address?.city.length > 50
        //     ? getMessage.city_maxLength
        //     : ""
        //   : getMessage.city_required,
        city:"",
        // state: _userData?.address?.state
        //   ? _userData?.address?.state.length > 50
        //     ? getMessage.state_maxLength
        //     : ""
        //   : getMessage.state_required,
        state: "",
        // pincode:
        //   _userData?.address?.pincode == ""
        //     ? getMessage.pincode_required
        //     : _userData?.address?.pincode.length == 6
        //       ? ""
        //       : getMessage.pincode_length,
        pincode: "",
        email:
          _userData?.email == ""
            ? getMessage.email_required
            : emailValidation(_userData?.email) == null
              ? getMessage.email_matches
              : "",
      });
    } else {
      if (!result?.response?.data?.data?.allowForBooking) {
        setDisableAll(true);
        toast.error(result.response.data.message);
      } else {
        updateData({
          ...data,
          image: "",
          firstName: "",
          lastName: "",
          addressLine1: "",
          addressLine2: "",
          landmark: "",
          city: "",
          country: "India",
          latitude: "",
          longitude: "",
          pincode: "",
          email: "",
          state: "",
          gender: "",
          aadharNumber: "",
          birthDate: "",
          schoolName: "",
          parentName: "",
          whatsAppNumber: "",
          haveIdProof: "",
        });
        setDisableAll(false);
        setVerifiedUser({});
      }
    }
  };

  const setStringValue = (key = "", value = "") => {
    if (validateAlphabet(value)) {
      updateData(key, value);
    }
  };



  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, value);
    }
  };

  const setValueWithLengthAndPositive = (
    key = "",
    value = "",
    min = 0,
    max = 0
  ) => {
    if (
      validateCharacterLength(value, min, max) &&
      validatePositiveValue(value)
    ) {
      updateData(key, value);
    }
  };
  const GetAmount = async () => {
    let payload = {
      sessionId: data.sessionId,
      noOfDays: data.noOfDays,
      noOfWeeks: Number(data.noOfWeeks),
      selectedSlots: data.selectedSlots.map((item: any) => item.value),
      startDate: format(new Date(data?.startDate), "yyyy-MM-dd"),
      isIgstTax: "false",
      discount: data?.discount,
    };
    const result = await SessionBookingAmount(payload);
    if (result.status == 200) {
      let amountData: any = result?.data?.data;
      setAmountData({ ...amountData });
    } else {
      toast.error(result.response.data.message);
    }
  };
  useEffect(() => {
    GetAmount();
  }, [data?.discount]);


  useEffect(() => {
    setVerifyButton(false);
  }, [data?.phone]);

  return (
    <>
      <Card.Title className="text-start">Coaching Booking</Card.Title>
      <Row>
        <Col lg={12}>
          <ImageUpload
            value={data?.image}
            onChange={(img) => {
              updateData("image", img);
              setError((prev: any) => ({ ...prev, image: "" }));
            }}
            onError={(err) => setImgError(err)}
            error={imgError || error?.image}
            disabled={verifiedUser["image"] || disableAll}
            showWebcam={!verifiedUser["image"]}
            label="Upload Latest Photo through upload option"
          />
        </Col>
      </Row>
      <Row>
        <Col col={6}>
          <div className="mb-3 text-start">
            <label htmlFor="voicecallnum" className="form-label">
              Voice Call Number <small className="text-danger">*</small>
            </label>
            <InputGroup>
              <Input
                type="number"
                placeholder="Enter Voice Call Number"
                id="voicecallnum"
                name="voicecallnum"
                className="form-control"
                value={data?.phone || ""}
                onChange={(e: any) => {
                  setSendOtp((_oldValue: any) => ({
                    ..._oldValue,
                    phone: e.target.value,
                  }));
                  updateData("phone", e.target.value);
                }}
                onKeyDown={(e: any) =>
                  ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                }
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSend();
                  }
                }}
                onWheel={(e: any) => e.target.blur()}
              />
              <Button
                type="button"
                disabled={verifyButton}
                bname={verifyButton ? "Verified" : "Verify"}
                name="verify"
                id="verify"
                className="btn btn-sm btn-primary rounded-1"
                onClick={handleSend}
              ></Button>
            </InputGroup>
            <span className="error-msg">{error?.phone}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="schoolname" className="form-label">
              School Name
            </label>
            <Input
              type="text"
              placeholder="Enter School Name"
              id="schoolname"
              name="schoolname"
              className="form-control"
              value={data?.schoolName || ""}
              onChange={(e: any) => updateData("schoolName", e.target.value)}
              disabled={verifiedUser["schoolName"] || disableAll}
            />
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <Row>
              <Col lg={6}>
                <label htmlFor="membername" className="form-label">
                  Attendee First Name <small className="text-danger">*</small>
                </label>
                <Input
                  type="text"
                  placeholder="First Name"
                  id="firstName"
                  name="firstName"
                  className="form-control"
                  value={data?.firstName || ""}
                  onChange={(e: any) => updateData("firstName", e.target.value)}
                  disabled={false}
                />
                <span className="error-msg">{error?.firstName}</span>
              </Col>
              <Col lg={6}>
                <label htmlFor="membername" className="form-label">
                  Attendee Last Name <small className="text-danger">*</small>
                </label>
                <Input
                  type="text"
                  placeholder="Last Name"
                  id="lastName"
                  name="lastName"
                  className="form-control"
                  value={data?.lastName || ""}
                  onChange={(e: any) => updateData("lastName", e.target.value)}
                  disabled={false}
                />
                <span className="error-msg">{error?.lastName}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="parentname" className="form-label">
              Parent Name
            </label>
            <Input
              type="text"
              placeholder="Enter Parent Name"
              id="parentName"
              name="parentName"
              className="form-control"
              value={data?.parentName || ""}
              onChange={(e: any) => updateData("parentName", e.target.value)}
              disabled={false}
            />
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <Row>
              <Col lg={6}>
                <label htmlFor="gender" className="form-label">
                  Gender
                  {/* <small className="text-danger">*</small> */}
                </label>
                <DropDown
                  className="form-control"
                  id="gender"
                  name="gender"
                  value={data?.gender || ""}
                  onChange={(e: any) => updateData("gender", e.target.value)}
                  disabled={false}
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </DropDown>
                <span className="error-msg">{error?.gender}</span>
              </Col>
              <Col lg={6}>
                <label htmlFor="membername" className="form-label">
                  Email <small className="text-danger">*</small>
                </label>
                <Input
                  type="email"
                  placeholder="Enter Email Address"
                  id="email"
                  name="email"
                  className="form-control"
                  value={data?.email || ""}
                  required={data?.email != ""}
                  onChange={(e: any) => updateData("email", e.target.value)}
                  disabled={false}
                />
                <span className="error-msg">{error?.email}</span>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="whatsappnum" className="form-label">
              WhatsApp Number
            </label>
            <Input
              type="number"
              placeholder="Enter WhatsApp Number"
              id="whatsAppNumber"
              name="whatsAppNumber"
              className="form-control"
              value={data?.whatsAppNumber || ""}
              onChange={(e: any) =>
                setValueWithLengthAndPositive(
                  "whatsAppNumber",
                  e.target.value,
                  0,
                  10
                )
              }
              disabled={verifiedUser["whatsAppNumber"] || disableAll}
              onKeyDown={(e: any) =>
                ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
              }
              onWheel={(e: any) => e.target.blur()}
            />
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="dob" className="form-label">
              Date of Birth (DD/MM/YYYY){" "}
              <small className="text-danger">*</small>
            </label>
            <DatePicker
              id="birthDate"
              inputClass="form-control"
              format="DD/MM/YYYY"
              containerClassName="custom-container"
              onChange={(date: any) =>
                updateData("birthDate", date?.toDate().toUTCString())
              }

              value={data?.birthDate ? getFormatedDate(data?.birthDate) : ""}
              render={
                <InputIcon
                  className={
                    verifiedUser["birthDate"]
                      ? "form-control bg-light d-inline-block"
                      : "form-control"
                  }
                  style={
                    verifiedUser["birthDate"] ? { pointerEvents: "none" } : {}
                  }
                />
              }
              disabled={false}
              readOnly={false}
              maxDate={new Date()}
            />
            <span className="error-msg">{error?.birthDate}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="aadharnum" className="form-label">
              Aadhar Number
            </label>
            <Input
              type="number"
              placeholder="Enter Aadhar Number"
              id="aadharnum"
              name="aadharnum"
              className="form-control"
              value={data?.aadharNumber || ""}
              onChange={(e: any) =>
                setValueWithLengthAndPositive(
                  "aadharNumber",
                  e.target.value,
                  0,
                  12
                )
              }
              disabled={false}
              onKeyDown={(e: any) =>
                ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
              }
              onWheel={(e: any) => e.target.blur()}
            />
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="address" className="form-label">
              Address Line 1
              {/* <small className="text-danger">*</small> */}
            </label>
            <Input
              type="text"
              placeholder="Enter Address"
              id="addressLine1"
              name="addressLine1"
              className="form-control"
              value={data?.addressLine1 || ""}
              onChange={(e: any) => updateData("addressLine1", e.target.value)}
              disabled={false}
            />
            <span className="error-msg">{error?.addressLine1}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="address" className="form-label">
              Address Line 2
            </label>
            <Input
              type="text"
              placeholder="Enter Address"
              id="addressLine2"
              name="addressLine2"
              className="form-control"
              value={data?.addressLine2 || ""}
              onChange={(e: any) => updateData("addressLine2", e.target.value)}
              disabled={false}
            />
            <span className="error-msg">{error?.addressLine2}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="landmark" className="form-label">
              Landmark
            </label>
            <Input
              type="text"
              placeholder="Enter Landmark"
              id="landmark"
              name="landmark"
              className="form-control"
              value={data?.landmark || ""}
              onChange={(e: any) => updateData("landmark", e.target.value)}
              disabled={false}
            />
            <span className="error-msg">{error?.landmark}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="city" className="form-label">
              City
              {/* <small className="text-danger">*</small> */}
            </label>
            <Input
              type="text"
              placeholder="Enter City"
              id="city"
              name="city"
              className="form-control"
              value={data?.city || ""}
              onChange={(e: any) => updateData("city", e.target.value)}
              disabled={false}
            />
            <span className="error-msg">{error?.city}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="state" className="form-label">
              State
              {/* <small className="text-danger">*</small> */}
            </label>
            <DropDown
              name="state"
              id="state"
              className="form-control"
              value={data?.state || ""}
              onChange={(e: any) => updateData("state", e.target.value)}
              disabled={false}
            >
              <option value="">Select State</option>
              {states?.map((item: any) => {
                return (
                  <option key={item.code} value={item.name}>
                    {item.name}
                  </option>
                );
              })}
            </DropDown>
            <span className="error-msg">{error?.state}</span>
          </div>
        </Col>
        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="pincode" className="form-label">
              Pincode
              {/* <small className="text-danger">*</small> */}
            </label>
            <Input
              type="text"
              placeholder="Enter pincode"
              id="pincode"
              name="pincode"
              className="form-control"
              value={data?.pincode || ""}
              onChange={(e: any) =>
                setValueWithLengthAndPositive("pincode", e.target.value, 0, 6)
              }
              disabled={false}
              onKeyDown={(e: any) =>
                (e.key === "e" || e.key === ".") && e.preventDefault()
              }
            />
            <span className="error-msg">{error?.pincode}</span>
          </div>
        </Col>

        <Col lg={6}>
          <div className="mb-3 text-start">
            <label htmlFor="idproof" className="form-label">
              ID Proof Copy
            </label>

            <div className="d-flex">
              <Form.Check
                label="Yes"
                name="idproof"
                type="radio"
                id="yes"
                className="me-5"
                value="true"
                onChange={(e: any) => updateData("haveIdProof", true)}
                checked={data?.haveIdProof || ""}
              />
              <Form.Check
                label="No"
                name="idproof"
                type="radio"
                id="no"
                value="false"
                onChange={(e: any) => updateData("haveIdProof", false)}
                checked={!data?.haveIdProof}

              />
            </div>
          </div>
        </Col>

        <Col lg={6}>
          <div className="mb-3 text-start">
            <Form.Check
              onChange={(e: any) => {
                seIgstChecked(e.target.value);
              }}
              label="IGST"
              name="isIgstTax"
              type="checkbox"
              id="igst"
              value={!igstChecked ? "true" : "false"}
              checked={!igstChecked ? false : true}
            />
          </div>
        </Col>
      </Row>
      <Row></Row>

      <Row className="text-end">
        <hr />
        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Selected Weeks:{" "}
          </span>
          <span className="user-info">{data?.noOfWeeks}</span>
        </Col>
        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Charges Per Weeks:{" "}
          </span>
          <span className="user-info">
            <span className="rupees-symbol">&#8377;</span>{" "}
            {ratePerWeek?.toFixed(2)}
          </span>
        </Col>
        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Offer ({offerData?.discountPercent || 0}%):
          </span>
          <span className="user-info">
            -<span className="rupees-symbol">&#8377;</span>{" "}

            {offerData?.discountPercent > 0
              ? Math.ceil(
                ratePerWeek *
                data?.noOfWeeks *
                (offerData?.discountPercent / 100)
              )
              : 0}
          </span>
        </Col>
        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Sub Total:{" "}
          </span>
          <span className="user-info">
            <span className="rupees-symbol">&#8377;</span>{" "}
            {amount?.subTotal?.toFixed(2) || 0}
          </span>
        </Col>

        <Col md={{ span: 3, offset: 9 }}>
          <div className="mb-3">
            <Row className="align-items-baseline gx-2">
              <Col md={6}>
                <label
                  htmlFor="discount"
                  className="form-label text-uppercase text-info text-nowrap"
                >
                  Discount :
                </label>
              </Col>
              <Col md={6}>
                <Input
                  type="text"
                  placeholder="Discount"
                  id="discount"
                  name="discount"
                  className="form-control"
                  value={data?.discount || ""}
                  onChange={(e: any) =>
                    setPositiveValue("discount", e.target.value)
                  }
                />
              </Col>
            </Row>
          </div>
        </Col>

        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Total Tax({totalTax}%):{" "}
          </span>
          <span className="user-info">
            <span className="rupees-symbol">&#8377;</span>{" "}
            {amount?.totalTax?.toFixed(2) || 0}
          </span>
        </Col>
        <Col md={{ span: 4, offset: 8 }} className="mb-3">
          <span className="user-info-title text-info text-uppercase mb-2">
            Payable Amount:{" "}
          </span>
          <span className="user-info">
            <span className="rupees-symbol">&#8377;</span>{" "}
            {Math.round(amount?.totalAmount) || 0}
          </span>
        </Col>
        <Col md={{ span: 5, offset: 7 }}>
          <div className="mb-3 mt-3 text-end">
            <div className="d-flex justify-content-end">
              <Form.Check
                label="Collect Cash"
                name="payment"
                type="radio"
                id="collect-cash"
                className="me-5"
                value="cash"
                onChange={(e: any) =>
                  updateData("paymentMethod", e.target.value)
                }
                checked={data?.paymentMethod === "cash"}
              />
              <Form.Check
                label="Share Payment Link"
                name="payment"
                type="radio"
                id="payment-link"
                value="online"
                onChange={(e: any) =>
                  updateData("paymentMethod", e.target.value)
                }
                checked={data?.paymentMethod === "online"}
              />
            </div>
          </div>
        </Col>
      </Row>
      <VerifyOtpModal
        message={message}
        modalShow={modalShow}
        setModalShow={setModalShow}
        setMessage={setMessage}
        handleVerifiedUser={handleVerifiedUser}
        phone={data?.phone}
        otpFor={sendOtp?.otpFor}
        setDisableAll={setDisableAll}
      />
    </>
  );
};
export { AddCoachingBookingDetails };
